import { serverTime } from '@/contexts/chat/scripts/hooks/useSystemTime/utils';

interface CallTimerProps {
  startTime?: number;
}

const formatDuration = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n: number) => n.toString().padStart(2, '0');

  return hours > 0
    ? `${pad(hours)}: ${pad(minutes)}: ${pad(seconds)}`
    : `${pad(minutes)}: ${pad(seconds)}`;
};

const CallTimer = ({ startTime }: CallTimerProps) => {
  const [currentTime, setCurrentTime] = useState(serverTime.time);

  const elapsedSeconds = startTime ? Math.floor((currentTime - startTime) / 1000) : 0;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(serverTime.time);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!startTime || elapsedSeconds < 0) {
    return null;
  }

  return <div>{formatDuration(elapsedSeconds)}</div>;
};

export default CallTimer;
